export const LIMIT_OPTIONS = [
    { 'label': '20 records', value: '20' },
    { 'label': '50 records', value: '50' },
    { 'label': '100 records', value: '100' },
    // { 'label': '200 records', value: '200' },
    // { 'label': '500 records', value: '500' },
]
export const ORDERING_OPTIONS = [
    { 'label': 'ID Asc', value: 'id' },
    { 'label': 'ID Desc', value: '-id' },
    { 'label': 'Oldest First', value: 'created_at' },
    { 'label': 'Latest First', value: '-created_at' },
    { 'label': 'Oldest Updated', value: 'updated_at' },
    { 'label': 'Latest Updated', value: '-updated_at' },
]

export const DAYS_OPTIONS = [
    { 'label': 'Today', value: 'today' },
    { 'label': 'Yesterday', value: 'yesterday' },
    { 'label': 'Past 7 days', value: 'week' },
    { 'label': 'This month', value: 'month' },
    { 'label': 'This Year', value: 'year' },
]